export enum AuthLogoutTypes {
  SessionExpired = 'session_expired',
  UserLogout = 'user_logout',
}
